import React, { useEffect, useState } from 'react';
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import Headline from '../../../components/headline/Headline';
import Stylebutton from '../../../components/buttons/stylebutton/Stylebutton';
import { Alert, Box, Button, Card, Dropdown, IconButton, Input, Link, Menu, MenuButton, MenuItem, Table, Typography } from '@mui/joy';
import { haspermission } from '../../../Script/Permission';
import { useNavigate } from 'react-router-dom';
import { post, Token } from '../../../Script/Session';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import SearchIcon from '@mui/icons-material/Search';
import MoreVert from '@mui/icons-material/MoreVert';
import * as XLSX from 'xlsx';
import debounce from 'lodash/debounce';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
function Gesellschaftenhome() {
  const [wit, setwith] = useState("90.5%");
  const [pagelog, setpagelog] = useState(null);
  const [canedit, setcanedit] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  useEffect(() => {
    const handler = debounce(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);
    handler();
    return () => handler.cancel();
  }, [searchTerm]);

  useEffect(() => {
    const fetchVereinData = async () => {
      setLoading(true);
      const body = { token: Token.get(), action: "get" };
      try {
        let response = await post(body, "/gesellschaft");
        if (response === "LOGOUT") {
          navigate("/");
          return;
        }
        setData(JSON.parse(response));
        setpagelog(haspermission("17"));
        setcanedit(haspermission("21"));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    setTimeout(fetchVereinData, 100);
  }, [navigate]);

  const handleClick = () => document.getElementById("excel-file-input").click();

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      let body = { token: Token.get(), action: "create" };
      const arrayBuffer = await file.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
      body.list = jsonData;
      let response = await post(body, "/gesellschaft");
      if (response === "LOGOUT") navigate("/");
      if (response === "OK") {
        // refresh or show notification
      }
    }
  };

  const [edname, setedname] = useState("");
  const [edstase, setedstrase] = useState("");
  const [edplz, setedplz] = useState("");
  const [edort, setedort] = useState("");
  const [edland, setedland] = useState("");
  const [edregnummer, setedregnummer] = useState("");
  const [edbafin, setedbafin] = useState("");
  const [edgattung, setedgattung] = useState("");
  const [create,setcreate] = useState(false);
  const [a,seta] = useState(false);
  const [slice, setslice]= useState(100);

  function remove(d){
    let body = {
      token: Token.get(),
      action: "delete",
      id: d,
    }
    let response = post(body, "/gesellschaft");
    if (response == "LOGOUT"){
      navigate("/");
    }
    if (response == "OK"){
      fetchVereinData();
      seta(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  const add = () => {
    let json = {
      NAME: edname,
      STRASSE: edstase,
      PLZ: edplz,
      ORT: edort,
      LAND: edland,
      "REG NR": edregnummer,
      "BAFIN-ID": edbafin,
      GATTUNG: edgattung
    };
    let li = [json];

    let body = {
      token: Token.get(),
      action: "create",
      list: li,
    };
    let response = post(body, "/gesellschaft");
    if (response == "LOGOUT"){
      navigate("/");
    }
    if (response == "OK"){
      fetchVereinData();
      seta(true);
    }
  };
    const fetchVereinData = () => {
      setLoading(true);
      const body = { token: Token.get(), action: "get" };
      try {
        let response = post(body, "/gesellschaft");
        if (response === "LOGOUT") {
          navigate("/");
          return;
        }
        setData(JSON.parse(response));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  return (
    <>
      <div style={{ width: wit, position: "fixed", overflowY: "auto", flexDirection: "column", top: 0, right: 0, backgroundColor: "#eeeeee", height: "100vh", display: "flex", alignItems: "center" }}>
        <Headline title="Gesellschaften" />
        <div style={{ overflowX: "hidden", overflowY: "auto", height: "94.5%", width: "100%", display: "flex", alignItems: "center", flexDirection: "column" }}>
          <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", mt: 3, mb: 3, width: "100%" }}>
            {canedit && (
              <div onClick={handleClick}>
                <Stylebutton buttonText="Exel Importieren" />
                <input
                  id="excel-file-input"
                  type="file"
                  accept=".xls,.xlsx"
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                />
              </div>
            )}
            {canedit && <div onClick={() => setcreate(!create)}><Stylebutton buttonText="Hinzufügen" /></div>}
            {pagelog && <div onClick={() => navigate("/page-history/gesellschaften")}><Stylebutton buttonText="SeitenHistorie" /></div>}
          </Box>
        {
            a && (
                <Alert
                sx={{mb: 5}}
                variant="soft"
                color="success"
                startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
                endDecorator={
                    <Button size="sm" variant="solid" color="success" onClick={() => seta(false)}>
                    Schliesen
                    </Button>
                }
                >
                Ihre änderungen wurden Erfolgreich gespeichert.
                </Alert>
            )
        }
          <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
            <Input
              placeholder="Suche..."
              startDecorator={<SearchIcon />}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ width: 300 }}
            />
          </Box>
          {
            create && (
                <Card variant="soft" sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0, p: 2, mb: 5, width: "80%" }}>
                  <Typography level="title-md" sx={{ mb: 0 }}>Gesellschaft Erstellen</Typography>
                  <Typography sx={{ mb: 1 }}>Bitte gib alle unten genannten Felder an um eine neue Gesellschaft Anzulegen.</Typography>
                  <Typography>Name:</Typography>
                  <Input placeholder='Gesellschaftsname' value={edname} onChange={(e) => setedname(e.target.value)} />
                  <Typography sx={{ mt: 1 }}>Straße:</Typography>
                  <Input placeholder='Straße' value={edstase} onChange={(e) => setedstrase(e.target.value)} />
                  <Typography sx={{ mt: 1 }}>PLZ:</Typography>
                  <Input placeholder='PLZ' value={edplz} onChange={(e) => setedplz(e.target.value)} />
                  <Typography sx={{ mt: 1 }}>Ort:</Typography>
                  <Input placeholder='Ort' value={edort} onChange={(e) => setedort(e.target.value)} />
                  <Typography sx={{ mt: 1 }}>Land:</Typography>
                  <Input placeholder='Land' value={edland} onChange={(e) => setedland(e.target.value)} />
                  <Typography sx={{ mt: 1 }}>REG-NR:</Typography>
                  <Input placeholder='REG-NR' value={edregnummer} onChange={(e) => setedregnummer(e.target.value)} />
                  <Typography sx={{ mt: 1 }}>BAFIN:</Typography>
                  <Input placeholder='BAFIN' value={edbafin} onChange={(e) => setedbafin(e.target.value)} />
                  <Typography sx={{ mt: 1 }}>Gattung:</Typography>
                  <Input placeholder='Gattung' value={edgattung} onChange={(e) => setedgattung(e.target.value)} />
                  <Button sx={{ height: "5%", mt: 3 }} startDecorator={<SaveOutlinedIcon />} onClick={add}>Speichern</Button>
                </Card>
            )
          }


          {loading ? <Typography>Wird geladen!</Typography> : (
            <Table sx={{ '& thead th:nth-child(1)': { width: "25%" } }}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Straße</th>
                  <th>PLZ</th>
                  <th>ORT</th>
                  <th>LAND</th>
                  <th>REG-NR</th>
                  <th>BAFIN</th>
                  <th>Gattung</th>
                  {canedit && <th>Bearbeiten</th>}
                </tr>
              </thead>
              <tbody>
                {data?.result
                  ?.filter(item => item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase()))
                  .slice(0, slice)
                  .map(item => (
                    <tr key={item.id}>
                      <td>{item.name}</td>
                      <td>{item.straße}</td>
                      <td>{item.PLZ}</td>
                      <td>{item.ORT}</td>
                      <td>{item.LAND}</td>
                      <td>{item.REGNR}</td>
                      <td>{item.BAFIN}</td>
                      <td>{item.gattung}</td>
                      {canedit && (
                        <td>
                          <Dropdown>
                            <MenuButton slots={{ root: IconButton }} slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}>
                              <MoreVert />
                            </MenuButton>
                            <Menu>
                              <MenuItem onClick={() => remove(item.id)} sx={{ color: "red" }}>Gesellschaft löschen</MenuItem>
                            </Menu>
                          </Dropdown>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </Table>
            
          )}
          {
            !loading && (
              <Button sx={{mt: 2, mb: 2}} onClick={()=> setslice(slice + 100)}>Mehr Laden</Button>
            )
          }

        </div>
      </div>
      <NavigationBar state="vergleiche" back={true} />
    </>
  );
}

export default Gesellschaftenhome;
